// import { useAttributeStore } from "@/stores/currencies-store";
class SkuUtils {
    
    extractAttributes (product) {
        if (process.client) {
            const attributeLocal = (JSON.parse(localStorage.getItem("all-attributes")))
            if (product && product.skus && product.skus.length > 0) {

                let skus = product.skus;
                let foundValueIds = [];
                let flattenedObjs = [];
                let tempFlattenedObjs = {};
                
                for (let i = 0; i < skus.length; i++) {
    
                    let sku = skus[i];
    
                    for (let j = 0; j < sku.attributeValues.length; j++) {
                        
                        let attributeValue = sku.attributeValues[j];
                        let option = attributeValue.option;
                        let extras = {};
                        let extrasColor = '';
                        // let hasExtras = attributeLocal.attributes.filter(i => i.discriminator == false && i.optionId == option.id && i.id == attributeValue.id);
                        let hasAttri = attributeLocal.attributes.filter(i => i.discriminator == false && i.id == option.id);
                        if (hasAttri.length > 0) {
                            
                            let hasExtras = hasAttri[0].values.filter(i => i.id == attributeValue.id && i.optionId == option.id);
                            if (hasExtras[0].extras && hasExtras[0].extras.value && hasExtras[0].extras.value.length > 0) {
                                
                                extras = hasExtras[0].extras;
                                if (hasExtras[0].extras != '#ffffff' || hasExtras[0].extras != '#fff') {
                                    extrasColor = '#ffffff';
                                } else {
                                    extrasColor = '#000000';
                                }
                            }
                        }
                        // if (foundValueIds.includes(attributeValue.id)) continue; //is not working properly
                        if (foundValueIds.find(v => v.id == attributeValue.id && v.optionId == option.id)) continue; 
    
                        if (tempFlattenedObjs[option.name]) {
    
                            tempFlattenedObjs[option.name].values.push({
                                code: sku.code,
                                id: attributeValue.id,
                                optionId: option.id,
                                seq: attributeValue.sortOrder,
                                name: attributeValue.name,
                                optionName: option.name,
                                salesPrice: sku.salesPrice,
                                extrasVal: extras && extras.value && extras.value.length > 0 ? extras.value : '',
                                textColor: extrasColor,
                                extrasType: extras && extras.value && extras.value.length > 0 ? extras.valueType : '',
                                optionDisplayLabel: option.displayLabel,
                                displayLabel: attributeValue.displayLabel,
                                label: attributeValue.displayLabel,
                                discountedSalesPrice: sku.discountedSalesPrice
                            });
                            // tempFlattenedObjs[option.name] = {
                            //     productCode: product.code,
                            // }
                        } else {
    
                            tempFlattenedObjs[option.name] = {
    
                                name: option.name,
                                optionDisplayLabel: option.displayLabel,
                                optionId: option.id,
                                // productCode: product.code,
                                values: [{ 
                                    code: sku.code,
                                    id: attributeValue.id, 
                                    optionId: option.id,
                                    seq: attributeValue.sortOrder, 
                                    name: attributeValue.name,
                                    optionName: option.name,
                                    extrasVal: extras && extras.value && extras.value.length > 0 ? extras.value : '',
                                    textColor: extrasColor,
                                    extrasType: extras && extras.value && extras.value.length > 0 ? extras.valueType : '',
                                    optionDisplayLabel: option.displayLabel,
                                    displayLabel: attributeValue.displayLabel,
                                    label: attributeValue.displayLabel,
                                    salesPrice: sku.salesPrice,
                                    discountedSalesPrice: sku.discountedSalesPrice
                                }],
    
                            };
                        }
                        // foundValueIds.push(attributeValue.id);
                        foundValueIds.push({id:attributeValue.id, optionId: option.id});
                    }
                }
    
                Object.keys(tempFlattenedObjs).forEach((key) => {
                    tempFlattenedObjs[key].values = tempFlattenedObjs[key].values.sort((a,b) => a.seq - b.seq);
                });
    
                Object.keys(tempFlattenedObjs).forEach((key) => {
                    flattenedObjs.push(tempFlattenedObjs[key]);
                });
    
                return flattenedObjs;
            }
        return [];
        }
        return [];
    }
    
    findSkuByAttributeValues (skus, attributeValues) {
        
        for (let i = 0; i < skus.length; i++) {

            if (skus[i].attributeValues.length == attributeValues.length) {
                let matchCount = 0;

                for (let j = 0; j < skus[i].attributeValues.length; j++) {

                    for (let k = 0; k < attributeValues.length; k++) {
                        let attrInSku = skus[i].attributeValues[j];
                        let attrPassed = attributeValues[k];
                        
                        // console.log(attrPassed.id + " -- " + attrInSku.id);
                        
                        if (attrInSku.id == attrPassed.id && attrInSku.optionId == attrPassed.optionId) {
                            matchCount++;
                        }
                    }
                }

                if (matchCount == attributeValues.length)
                    return JSON.parse(JSON.stringify(skus[i]));
            }
        }
        return null;
    }

    skuTotalQuantity (product,sku) {
        let stock = 0;
        let stockObject = product.stocks.find(s => s.skuCode === sku.code && s.locationId == 'L832HPGO--1SAV72D78RQDW-H5JXR1ADY6IT');
       
        if (sku && stockObject) {
            // for (let j = 0; j < sku.stocks.length; j++) {
            //     stock += Number(sku.stocks[j].total);
            // }
            stock = stockObject.ok;
        }
        
        return stock;
    }

    extractPrice (sku) {
        if (Number(sku.discountedSalesPrice) > 0) return Number(sku.discountedSalesPrice);
        return Number(sku.salesPrice);
    }
    
    // no needs 
    extractDefaultSku (product) {
        if (product && product.skus && product.skus.length > 0) {
            let foundDefaultSkuCode = product.defaultSkuCode;

            if (!foundDefaultSkuCode || foundDefaultSkuCode.trim() == "") {
                console.log("extractDefaultSku11111111");
                return JSON.parse(JSON.stringify(product.skus[0]));
            }

            for (let i = 0; i < product.skus.length; i++) {
                console.log("extractDefaultSku2222222");

                let sku = product.skus[i];

                if (sku.code == foundDefaultSkuCode) {
                    // return sku;
                    return JSON.parse(JSON.stringify(sku));
                }
            }
        }
        
        return null;
    }

    extractDefaultSkuAttributes (product) {
        let defaultSku = this.extractDefaultSku(product);
        if (defaultSku)
            return defaultSku.attributeValues;
        return [];
    }

    mergeSelection (selection, selectedAttribute) {
        console.log("============mergeSelection================");
        console.log(selection);
        console.log(selectedAttribute);
        for (let i = 0; i < selection.length; i++) {
            console.log("selection.length");
            if (selection[i].name == selectedAttribute.name) {
                console.log("selection[i].name == selectedAttribute.name");
                selection[i] = selectedAttribute;
                break;
            }
        }
        console.log(selection);
        return JSON.parse(JSON.stringify(selection));
    }
   
    totalStock (product) {
        if (product && product.skus && product.skus.length > 0) {
            let skus = product.skus;
            let stock = 0;
            for (let i = 0; i < skus.length; i++) {
                let sku = skus[i];
              for (let j = 0; j < sku.stocks.length; j++) {
                stock += Number(sku.stocks[j].total);
              }
            }
            return stock;
        }
        return null;
    }
}

let skuUtils = new SkuUtils();
export default skuUtils;